export const MenuItems = [
	{
		title: "stories",
		url: "/stories",
		cName: "nav-links",
	},
	{
		title: "features",
		url: "/features",
		cName: "nav-links",
	},
	{
		title: "pricing",
		url: "/pricing",
		cName: "nav-links",
	},
];

export const MenuItemsFooter = [
	{
		title: "Home",
		url: "/",
		cName: "footer__link",
	},
	{
		title: "stories",
		url: "/stories",
		cName: "footer__link",
	},
	{
		title: "features",
		url: "/features",
		cName: "footer__link",
	},
	{
		title: "pricing",
		url: "/pricing",
		cName: "footer__link",
	},
];
